export function getGuideBookPath(
  guideId: string,
  travelDate?: string,
  city?: string,
  travelers?: number
) {
  const params = new URLSearchParams();
  if (travelDate) params.set('date', travelDate);
  if (city) params.set('city', city);
  if (travelers && travelers > 1) params.set('travelers', String(travelers));
  const query = params.toString();
  return query ? `/guides/${guideId}/book?${query}` : `/guides/${guideId}/book`;
}

export function getGuideProfilePath(
  guideId: string,
  travelDate?: string,
  city?: string,
  travelers?: number
) {
  const params = new URLSearchParams();
  if (travelDate) params.set('date', travelDate);
  if (city) params.set('city', city);
  if (travelers && travelers > 1) params.set('travelers', String(travelers));
  const query = params.toString();
  return query ? `/guides/${guideId}?${query}` : `/guides/${guideId}`;
}
